import { render, staticRenderFns } from "./PasswordResetComponent.vue?vue&type=template&id=bd26cb18&scoped=true&"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetComponent.vue?vue&type=style&index=0&id=bd26cb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd26cb18",
  null
  
)

export default component.exports